import React, { Fragment } from 'react';
import spinnerIcon from '../../img/spinner.svg';
import carPriceIcon from '../../img/car-price.svg';

function PriceBlock(props) {
  function renderPrice() {
    if (props.showClientPriceOnly) {
      const val = props.clientPrice ? props.clientPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : '';

      return (
        <Fragment>
          <div className="tit flex flex_align-items-center">
            <img src={carPriceIcon} alt="price" className="tit-car-price" />
            {props.strings.clientPrice}
          </div>
          <div className="value">{val} $</div>
        </Fragment>
      );
    } else if (props.isLoadingMarketPrice) {
      return (
        <Fragment>
          <div className="tit">{props.strings.market}</div>
          <img src={spinnerIcon} alt="loading" />
        </Fragment>
      );
    } else if (props.marketPrice > 0) {
      return (
        <Fragment>
          <div className="tit">{props.strings.market}</div>
          <div className="value">{props.marketPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} $</div>
          <div className="value value-uah">{props.marketPriceUah.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} грн</div>
        </Fragment>
      );
    } else if (!props.marketPrice && !isEmptyFields()) {
      return (
        <div className="text">{props.strings.noPrice}</div>
      );
    } else {
      return (
        <div className="text">{props.strings.isEmptyFields}</div>
      );
    }
  }

  function isEmptyFields() {
    const { car_name, car_model, car_year, car_fuel, car_trans, car_distance, region, city } = props.carsData;

    if (!car_name || !car_model || !car_year || !car_fuel || !car_trans || car_distance.length === 0 || !region || !city) {
      return true;
    }

    return false;
  }

  return (
    <div className="left-block k-price">
      {/* <div className="item i-bg">
        <div className="tit">{props.strings.minPrice}</div>
        <div className="value">{props.minPrice} грн/{props.strings.year2}</div>
        <div className="too-info">
          <svg width={14} height={10} viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5H13M13 5L8.44512 1M13 5L8.44512 9" stroke="#0A7E3E" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><path d="M1 5H13M13 5L8.44512 1M13 5L8.44512 9" stroke="#189851" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
          </svg>{props.strings.cashback} - 500 грн
        </div>
      </div> */}
      <div className="item">
        {renderPrice()}
      </div>
    </div>
  );
}

export default PriceBlock;
